import { createModule } from '../../createModule';
export const createMonthlyRollAPI = createModule(({ http }) => ({
    getMonthlyRoll: async (params) => {
        const res = await http.get(`/v2/monthly_roll/`, {
            params,
        });
        return res;
    },
    sendEmail: async (params) => {
        const res = await http.post(`/v2/monthly_roll/send`, {
            body: params,
        });
        return res;
    },
}));
